import {useEffect} from 'react'
import {AreawiseEditModalHeader} from './AreawiseEditModalHeader'
import {AreawiseEditModalFormWrapper} from './AreawiseEditModalFormWrapper'

const AreawiseEditModal = () => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_areawise'
        role='dialog'
        tabIndex={-1}
        area-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <AreawiseEditModalHeader />
            {/* begin::Modal body */}
            <div className='modal-body  over'>
              <AreawiseEditModalFormWrapper />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {AreawiseEditModal}
